import React from "react";
import { useTranslation } from "react-i18next";
import { Action } from "~/api/GeneratedApi";
import GenericTable, {
  CustomColumn,
  CustomTableProps,
} from "~/components/GenericTable";
import { useDateFormatter } from "~/utils/hooks/useDateFormatter";

type ActionsListProps = {
  data: Action[];
};

export const WaterTrafficSignList = ({ data }: ActionsListProps) => {
  const { t } = useTranslation("waterTrafficSignSearch");
  const dateFormatter = useDateFormatter();
  const columns = React.useMemo(
    (): CustomColumn<Action>[] => [
      {
        title: t("aton-action:date"),
        field: "timestamp",
        render: ({ timestamp }) =>
          timestamp ? dateFormatter({ date: timestamp }) : "",
      },
      { field: "type", title: t("aton-action:type") },
      { field: "memo", title: t("aton-action:information") },
    ],
    [dateFormatter, t],
  );

  const tableProps = React.useMemo(
    (): CustomTableProps<Action> => ({
      title: t("tableTitle"),
    }),
    [t],
  );
  return (
    <GenericTable<Action>
      data={data}
      columns={columns}
      tableProps={tableProps}
    />
  );
};
